export default "__VITE_ASSET__$QLyQNvg__"